<template>
  <!-- prettier-ignore -->
  <div class="benefitsTable">
    <table-header
      ref="tableHeader"
      :data="benefitsData.header"
      :selected-content-column="benefitsData.selectedContentColumn"
      class="benefitsTable-header"
      :class="{'benefitsTable-header--www': isWww}"
      @left="onHeaderScroll"
    />

    <ovp-table-rows
      ref="tableRows"
      :data="benefitsData"
      @left="onHorizontalScroll"
    />
  </div>
</template>
<script>
import OvpTableRows from '@/components/Container/Table/TableRows'
import TableHeader from '@/components/Container/Table/TableHeader'
import { renderIcon } from '@/components/Benefits/TooltipIcon'
import { EVENT_LANGUAGE_LOADED } from '@/config/events'
import { isEmpty } from 'lodash'

export default {
  name: 'OvpBenefitsTable',

  components: {
    TableHeader,
    OvpTableRows,
  },

  props: {
    benefitsData: {
      type: Object,
      required: true,
    },

    isWww: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ignoreScrollEventTable: false,
      ignoreScrollEventHeader: false,
    }
  },

  mounted() {
    if(isEmpty(this.$i18n.messages[this.$i18n.locale])){
      this.$EventBus.$once(EVENT_LANGUAGE_LOADED, this.addTooltips)
    } else {
      this.addTooltips()
    }
  },

  methods: {
    addTooltips() {
      const selectors = this.$el.querySelectorAll('[data-tooltip]')
      const content = this.$t('benefits.tooltip')
      selectors.forEach(selector => {
        const tooltipKey = selector.dataset?.tooltip.toLowerCase()
        const tooltip = content[tooltipKey] ? content[tooltipKey] : null

        if (tooltip) {
          selector.setAttribute('class', 'benefits__tooltip')
          selector.innerHTML = selector.innerHTML + ' '
          selector.insertAdjacentElement('afterend', renderIcon(tooltip))
        }
      })
    },

    onHeaderScroll(scrollLeft) {
      if (this.ignoreScrollEventHeader) {
        this.ignoreScrollEventHeader = false
        return
      }
      // ignore updates emitted from table position update
      this.ignoreScrollEventTable = true
      this.$refs.tableRows.$el.scrollLeft = scrollLeft
    },

    onHorizontalScroll(scrollLeft) {
      if (this.ignoreScrollEventTable) {
        this.ignoreScrollEventTable = false
        return
      }

      // ignore updates emitted from header position update
      this.ignoreScrollEventHeader = true

      this.$refs.tableHeader.$el.scrollLeft = scrollLeft
    },
  },
}
</script>

<style name="global">
.benefitsTable {
  em {
    font-style: normal;
    font-weight: bold;
  }
  ul {
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  ul li {
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
}
</style>

<style name="mobile" scoped>
.benefitsTable {
  background-color: var(--c-white);
  font-size: 14px;
  line-height: 20px;
  color: #666666;

  &-header {
    position: sticky;
    top: 0;
    background-color: var(--c-white);
    z-index: 1;
    overflow-x: auto;
    vertical-align: top;

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
}
</style>
<!-- TODO Add again when mobile issues when displayed within tabs decided-->
<!--<style name="www" scoped>-->
<!--.benefitsTable-header&#45;&#45;www {-->
<!--  top: 50px;-->
<!--}-->
<!--@media only screen and (min-width: 442px) {-->
<!--  .benefitsTable-header&#45;&#45;www {-->
<!--    top: 90px;-->
<!--  }-->
<!--}-->
<!--@media only screen and (min-width: 1081px) {-->
<!--  .benefitsTable-header&#45;&#45;www {-->
<!--    top: 0;-->
<!--  }-->
<!--}-->
<!--</style>-->
